<!-- 创建时间2023/06/20 10:07:48 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：文件下载逻辑 -->
<template>
  <yxt-radio-group v-if="selectable" v-model="type" direction="row" :disabled="disabled">
    <yxt-radio :label="0">{{ $t('pc_kng_lbl_downtype_sourcefile'/** 下载源文件 */) }}</yxt-radio>
    <yxt-radio :label="1">{{ $t('pc_kng_lbl_downtype_withwatermark'/** 下载带水印文件 */) }}</yxt-radio>
  </yxt-radio-group>
  <div v-else>{{ $t('pc_kng_lbl_downtype_privateUpload_desc'/** 学员下载的文件为源文件 */) }}</div>
</template>

<script>
import { KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
export default {
  name: 'form-download-source',
  inject: ['getWaterConfig', 'getInfo'],
  props: {
    value: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    batchSetting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {
    if (this.value === undefined) {
      this.type = this.selectable ? 1 : 0;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!this.selectable && val === 1) {
          this.type = 0;
        }
      }
    }
  },
  computed: {
    type: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    waterConfig() {
      return this.getWaterConfig();
    },
    info() {
      return this.getInfo();
    },
    selectable() {
      const {enabled, type} = this.waterConfig;
      return (enabled && type === 1 && !this.info.serverGroupId && this.info.type === KNG_TYPE.DOC) || this.batchSetting;
    }
  }
};
</script>